



import '../lib/pnotify/css/pnotify.css'
import PNotify from '../lib/pnotify/js/pnotify'
import bootbox from '../../assets/lib/bootbox/bootbox'
import Cookies from 'js-cookie'
import storeTree from '../../assets/js/store-tree';
let week = ['日', '一', '二', '三', '四', '五', '六']

function zero(num) {
    return num > 9 ? num : '0' + num
}
function getYearList() {
    let yearArr = [];
    let currentYear = new Date().getFullYear();
    for (let i = 2004; i <= currentYear + 1; i++) {
        yearArr.push(i);
    }
    return yearArr;
}

function formatZero(num) {
    if (num < 10) {
        return '0' + num
    } else {
        return num
    }
}

function setCookie(name, value) {
                    Cookies.set(name, value);
}

function getCookie(name) {


            return Cookies.get(name);
}

function delCookie(name) {
                    Cookies.remove(name);
}

let pNotify = (title, content, type) => {
    new PNotify({
        title: title,
        text: content || false,
        delay: content ? 4000 : 2000,
        type: type || 'notice',
        buttons: {
            closer_hover: false,
            sticker: false
        }
    })
}

let pNotify_long = (title, content, type) => {
    new PNotify({
        title: title,
        text: content || false,
        delay: 60000*60,
        type: type || 'notice',
	    buttons: {
	    	closer_hover: false,
            sticker: false,
	        closer:true
	    }
    })
}
function getLastDay(year, month) {
    var new_year = year;     var new_month = month++;     if (month > 12)     {
        new_month -= 12;         new_year++;     }
    var new_date = new Date(new_year, new_month, 1);     return (new Date(new_date.getTime() - 1000 * 60 * 60 * 24)).getDate(); }

var browser = {
    versions: function () {
        var u = navigator.userAgent,
            app = navigator.appVersion;
        return {             trident: u.indexOf('Trident') > -1,             presto: u.indexOf('Presto') > -1,             webKit: u.indexOf('AppleWebKit') > -1,             gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,             mobile: !!u.match(/AppleWebKit.*Mobile.*/),             ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),             android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,             iPhone: u.indexOf('iPhone') > -1,             iPad: u.indexOf('iPad') > -1,             webApp: u.indexOf('Safari') == -1         };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
}

module.exports = {
    isMobile() {
        if (browser.versions.mobile || browser.versions.ios || browser.versions.android ||
            browser.versions.iPhone || browser.versions.iPad) {
            return true;
        } else {
            return false;
        }
    },

    getQueryString(name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        let r = window.location.search.substr(1).match(reg);         let context = '';
        if (r != null) {
            context = r[2];
        }
        reg = null;
        r = null;
        return context == null || context == '' || context == 'undefined' ? '' : context;
    },

    saveToken(token) {
                setCookie(SERVER+'account.token', token);
    },
    getToken() {
                        return getCookie(SERVER+'account.token');
                                                    },


    removeToken: function () {
                delCookie(SERVER+'account.token')
    },
    delUserCookie: function (name) {
                        Cookies.remove(name);
    },
    isEmptyObject(obj) {
        for (let key in obj) {
            return false
        }

        return true
    },


    getTimeStr(time) {
        let now = Date.now()
        let dirTime = now - time
        if (dirTime < 60000) {
            return '刚刚'
        }
        if (dirTime < 3600000) {
            return Math.floor(dirTime / 60000) + '分钟前'
        }
        if (dirTime < 24 * 3600000) {
            return Math.floor(dirTime / 3600000) + '小时前'
        }
        let date = new Date()
        date.setTime(time)
        return zero(date.getMonth() + 1) + '月' + zero(date.getDate()) + '日 周' + week[date.getDay()]
    },
    getLastMonthFirtDay(){
    	return this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth()-1, 1).getTime());
    },
    getLastMonthLastDay(){
    	var date = new Date();
    	var day = new Date(date.getFullYear(), date.getMonth(), 0).getDate();
    	return this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth()-1, day).getTime());
    },
    formatDate(timestamp) {
        if (timestamp === null) {
            return timestamp;
        }
        if (timestamp === "") {
            return timestamp;
        }

        let date = new Date(timestamp)
        let timeString = ''
        timeString += date.getFullYear() + '-'
        timeString += formatZero(+date.getMonth() + 1) + '-'
        timeString += formatZero(date.getDate())
        return timeString
    },
    formatDate_toDay(timestamp) {
        if (timestamp === null) {
            return timestamp;
        }
        if (timestamp === "") {
            return timestamp;
        }

        let date = new Date(timestamp)
        let timeString = ''
        timeString += formatZero(date.getDate())
        return timeString
    },
    formatDateTime(timestamp) {
        if (timestamp === null) {
            return timestamp;
        }

        if (timestamp === "") {
            return timestamp;
        }
        let date = timestamp ? new Date(timestamp) : new Date();
        let timeString = ''
        timeString += date.getFullYear() + '-'
        timeString += formatZero(+date.getMonth() + 1) + '-'
        timeString += formatZero(date.getDate()) + ' '
        timeString += formatZero(date.getHours()) + ':'
        timeString += formatZero(date.getMinutes()) + ':'
        timeString += formatZero(date.getSeconds())
        return timeString
    },
    getYearMonth(time) {
        let date = new Date()
        if (time) {
            date.setTime(time)
        }
        return date.getFullYear() + '年' + zero(date.getMonth() + 1) + '月'
    },
    getCurrentYearMonth() {
        let date = new Date()
        return date.getFullYear() + '-' + zero(date.getMonth() + 1)
    },
    getYearMonthSimple(time) {
        let date = new Date()
        if (time) {
            date.setTime(time)
        }
        return date.getFullYear() + '-' + zero(date.getMonth() + 1)
    },
    getYearMonthDaySimple(time) {
        let date = new Date()
        if (time) {
            date.setTime(time)
        }
        return date.getFullYear() + '-' + zero(date.getMonth() + 1) + '-' + zero(date.getDate())
    },

    getRangeDates(startTimeStamp, endTimeStamp) {
                let fixStart = startTimeStamp - ((startTimeStamp + 28800000) % 86400000);
        let fixEnd = endTimeStamp - ((endTimeStamp + 28800000) % 86400000) + 86400000;
        let range = [];
        for (; fixStart < fixEnd; fixStart += 86400000) {
            range.push(fixStart)
        }
        return range;
    },
    calculateBirthDate(idCard) {
        // 验证身份证长度
        if (idCard.length !== 18) {
            return '无效的身份证号码';
        }
        // 提取出生日期字符串
        const birthDateString = idCard.substring(6, 14);
        // 将字符串转换为日期对象
        // 注意：月份和日期需要减去1，因为JavaScript中的月份是从0开始的
        const year = parseInt(birthDateString.substring(0, 4), 10);
        const month = parseInt(birthDateString.substring(4, 6), 10) - 1;
        const day = parseInt(birthDateString.substring(6, 8), 10);

        // 创建一个日期对象
        const birthDate = new Date(year, month, day);

        // 验证日期是否有效（例如，2月30日无效）
        if (birthDate.getMonth() !== month) {
            return '无效的出生日期';
        }
        // 返回格式化后的出生日期字符串
        return `${birthDate.getFullYear()}-${birthDate.getMonth() + 1 < 10 ? '0' : ''}${birthDate.getMonth() + 1}-${birthDate.getDate() < 10 ? '0' : ''}${birthDate.getDate()}`;
    },
    getZeroDate(timeStamp) {
        return timeStamp - (timeStamp % 86400);
    },

    isPositiveInteger(s) {         let re = /^[0-9]+$/
        return re.test(s)
    },

    replaceDate(date) {
        date = date.split('-')
        return date[0] + '年' + date[1] + '月' + date[2] + '日'
    },

    hasHtmlTag(str) {
        return /<|>/.test(str)
    },

    isName(str) {
        return /^[\u4e00-\u9fa5]{2,6}$/.test(str.trim())
    },

    isPassword(str) {
        return /^\w{6,12}$/.test(str);
    },

    isPhone(str) {

        return /^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/.test(str.trim()) || /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(str.trim());
    },

    isEmail(str) {
        return /^.+@.+$/.test(str.trim())
    },

    htmlLength(html) {
        return html.replace(/<.*?>/g, '').replace(/(\s|\t|\r|\n|&nbsp;)+/g, '').length
    },
    isCardNo(ID) {
        ID = ID.trim();
        if (typeof ID !== 'string') return false;
        const city = {
            11: "北京",
            12: "天津",
            13: "河北",
            14: "山西",
            15: "内蒙古",
            21: "辽宁",
            22: "吉林",
            23: "黑龙江 ",
            31: "上海",
            32: "江苏",
            33: "浙江",
            34: "安徽",
            35: "福建",
            36: "江西",
            37: "山东",
            41: "河南",
            42: "湖北 ",
            43: "湖南",
            44: "广东",
            45: "广西",
            46: "海南",
            50: "重庆",
            51: "四川",
            52: "贵州",
            53: "云南",
            54: "西藏 ",
            61: "陕西",
            62: "甘肃",
            63: "青海",
            64: "宁夏",
            65: "新疆",
            71: "台湾",
            81: "香港",
            82: "澳门",
            91: "国外"
        };
        let birthday = ID.substr(6, 4) + '/' + Number(ID.substr(10, 2)) + '/' + Number(ID.substr(12, 2));
        let d = new Date(birthday);
        let newBirthday = d.getFullYear() + '/' + Number(d.getMonth() + 1) + '/' + Number(d.getDate());
        let currentTime = new Date().getTime();
        let time = d.getTime();
        let arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        let arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        let sum = 0,
            i, residue;

        if (!/^\d{17}(\d|x)$/i.test(ID)) {
            return false;
        }
        if (city[ID.substr(0, 2)] === undefined) {
            return false;
        }
        if (time >= currentTime || birthday !== newBirthday) {
            return false;
        }
        for (i = 0; i < 17; i++) {
            sum += ID.substr(i, 1) * arrInt[i];
        }
        residue = arrCh[sum % 11];
        if (residue.toUpperCase() !== ID.substr(17, 1).toUpperCase()) {
            return false;
        }
        return true;
    },

    error(title, content) {
        pNotify(title, content, 'error');
    },

    info(title, content) {
        pNotify(title, content, 'info');

    },

    notice(title, content) {
    	pNotify(title, content, 'notice');
    },

    notice_long(title, content) {
    	pNotify_long(title, content, 'notice');
    },

    success(title, content) {
        pNotify(title, content, 'success');
    },

    confirm(message, yesCb, noCb, focusConfirm) {
        if (typeof noCb === 'boolean') {
            focusConfirm = noCb;
            noCb = null;
        }
        bootbox.confirm({
            message: message,
            size: 'small',
            buttons: {
                confirm: {
                    label: '确定',
                    className: 'btn-primary',
                    focus: focusConfirm
                },
                cancel: {
                    label: '取消',
                    focus: !focusConfirm
                }
            },
            callback: function (result) {
                if (result) {
                    yesCb();
                } else {
                    noCb && noCb();
                }
            }
        })
    },
    confirmTitle(title,message, yesCb, noCb, focusConfirm) {
        if (typeof noCb === 'boolean') {
            focusConfirm = noCb;
            noCb = null;
        }
        bootbox.confirm({
            message: message,
            size: 'small',
            title: title,
            buttons: {
                confirm: {
                    label: '确定',
                    className: 'btn-primary',
                    focus: focusConfirm
                },
                cancel: {
                    label: '取消',
                    focus: !focusConfirm
                }
            },
            callback: function (result) {
                if (result) {
                    yesCb();
                } else {
                    noCb && noCb();
                }
            }
        })
    },
    alert(title, message, cb) {
        if (typeof message === 'function') {
            cb = message
            message = title
            title = undefined
        }
        bootbox.alert({
            size: 'small',
            title: title,
            message: message,
            callback: function () {
                cb && cb()
            }
        })
    },


    serializeArrayToObject(data, joinArray) {
        let object = {};
        let length = data.length;
        for (let i = 0; i < length; i++) {
            let temp = data[i];
            let value = temp.value.trim();
            if (!object.hasOwnProperty(temp.name)) {
                                if (temp.name.indexOf('List') > -1) {
                    object[temp.name] = [value];
                } else {
                    object[temp.name] = value;
                }
            } else {
                if (joinArray) {
                    object[temp.name] += ',' + value;
                } else {
                    let tempArray = [];
                                        if (Array.isArray(object[temp.name])) {
                        tempArray = [...object[temp.name]];
                    } else {
                        tempArray = [object[temp.name]];
                    }
                    tempArray.push(value);
                    object[temp.name] = tempArray;
                }
            }
        }
        return object;
    },


    renderSelect(url, select, valueKey, textKey, initValue, callback) {

        let $select = $(select);
        if (typeof initValue === 'function') {
            callback = initValue;
            initValue = '';
        }


        if ($select.data('rendered')) {
            if (initValue !== undefined) {
                $select.val(initValue);
            }
            return;
        }


        $select.data('rendered', true);


        $.get(SERVER + url, (json) => {

            if (json.status === 0) {
                let html = `<option value="">请选择</option>`;
                let valueKeyIsFunction = typeof valueKey === 'function';
                let textKeyIsFunction = typeof textKey === 'function';
                let selectData = Array.isArray(json.data) ? json.data : json.data.list;
                selectData.forEach((item) => {
                    let value = valueKeyIsFunction ? valueKeyIsFunction(item) : item[valueKey];
                    let text = textKeyIsFunction ? textKeyIsFunction(item) : item[textKey];
                    if (value == initValue) {
                        html += `<option  value="${value}" selected="selected">${text}</option>`;
                    } else {
                        html += `<option value="${value}">${text}</option>`;
                    }
                    $select.html(html);
                })
                callback && callback(selectData);
            }
        })
    },

    /**
     * 渲染 单选按钮组
     * @param id 标签id
     * @param options 数组 需要渲染的数据 label,value 形式
     * @param mode 模式 single单选 multiple多选
     */
    renderRadioButton(id, options, mode='single'){
        const element = $(id);

        options.forEach((item, index) => {
            let childHtml = `
            <div class="btn-item ${index === 0 ? 'active': ''}"  data-value="${item.value}">
                ${item.label}
            </div>
        `
            element.append(childHtml)
        })

        if (mode === 'single') {
            $(`${id} > .btn-item`).click(function(){
                $(this).addClass('active').siblings().removeClass('active')
            })
        }else {
            $(`${id} > .btn-item`).click(function(){
                if($(this).text().trim() === '全部') {
                    $(this).addClass('active').siblings().removeClass('active')
                }else {
                    $(`${id} > .btn-item:contains('全部')`).removeClass('active')
                    $(this).toggleClass('active')

                    //都没有选中时 选中全部  (子元素都没有.active)
                    if (element.children().not('.active').length === element.children().length) {
                        element.find(".btn-item:contains('全部')").addClass('active')
                    }
                }
            })
        }
    },

    /**
     * 重置 单选按钮组
     * @param id
     */
    renderRadioButtonReset(id){
        const targetList = $(id).find('.btn-item')
        targetList.each(function(i){
            i === 0 ? $(this).addClass("active"): $(this).removeClass('active')
        });
    },

    /**
     * 加密姓名
     * @param name
     * @returns {*|string}
     */
    maskName(name) {
        if (name.length <= 1) return name // 如果名字只有一个字符，直接返回
        return name.slice(0, 1) + "*".repeat(name.length - 1) // 获取第一个字符并重复星号
    },

                timeStamp(timestamp, separator) {
        var result = "";

        if (timestamp) {
            var reg = new RegExp(/\D/, "g");             var timestamp_str = timestamp.replace(reg, "");

            var d = new Date();
            d.setTime(timestamp_str);
            var year = d.getFullYear();
            var month = d.getMonth() + 1;
            var day = d.getDate();
            if (month < 10) {
                month = "0" + month;
            }
            if (day < 10) {
                day = "0" + day;
            }
            result = year + separator + month + separator + day;
        }
        return result;
    },
        formatTimeConversion(inputTime) {
        var date = new Date(inputTime);
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return h + ':' + minute;
    },
    formatTimeHm(inputTime) {
        var date = new Date(inputTime);
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        return h + ':' + minute;
    },
        formatTimeLocal(timestamp) {
        if (timestamp === null) {
            return timestamp;
        }
        if (timestamp === "") {
            return timestamp;
        }
        let date = timestamp ? new Date(timestamp) : new Date();
        let timeString = ''
        timeString += date.getFullYear() + '-'
        timeString += formatZero(+date.getMonth() + 1) + '-'
        timeString += formatZero(date.getDate()) + 'T'
        timeString += formatZero(date.getHours()) + ':'
        timeString += formatZero(date.getMinutes())
        return timeString
    },

    formatPrice(num) {
        return Number(num).toFixed(1).replace(/(\d)(?=(?:\d{3})+\.)/g, '$1,');
    },
    fixPrice(price) {
        let value = Math.round(price * 10) / 10;
        return value.toFixed(1);
    },

    difference(a, b) {
        let difference = a.concat(b).filter(v => !a.includes(v) || !b.includes(v));
        return difference;
    },
    getHeadImg(url) {
        if (url && url.includes('ywxt')) {
            return url && IMGSERVER + '/' + url;
        }
        return url && IMGSERVER + '/upload/image' + url;
    },
    getInterviewImg(url) {
        return 'https://ygdj-ywxt.oss-cn-qingdao.aliyuncs.com/' + url;
    },

    rendYearHtml($wrap) {
        const yearList = getYearList();
        const currentYear = new Date().getFullYear();
        let yearHtml = `<option value="">请选择</option>`;
        yearList.forEach((item) => {
            if (currentYear == item) {
                yearHtml += `<option value="${item}" selected>${item}年</option>`;
            } else {
                yearHtml += `<option value="${item}">${item}年</option>`;
            }
        })
        $wrap.html(yearHtml);
    },
    getMonth26() {
        var date = new Date();
        return {
            "start": (date.getMonth() == 0 ? date.getFullYear() - 1 : date.getFullYear()) + "-" + formatZero(date.getMonth() == 0 ? 12 : date.getMonth()) + "-26",
            "end": date.getFullYear() + "-" + formatZero(date.getMonth() + 1) + "-" + formatZero(date.getDate())
        };
    },
    getCurrentDay() {
        var date = new Date();
        return {
            "start": date.getFullYear() + "-" + formatZero(date.getMonth() + 1) + "-" + formatZero(date.getDate()),
            "end": date.getFullYear() + "-" + formatZero(date.getMonth() + 1) + "-" + formatZero(date.getDate())
        };
    },
    getCurrentYear() {
        var date = new Date();
        return {
    			"start": date.getFullYear() + "-01-01",
        		"end": date.getFullYear() + "-12-31" ,
        		"onlyYear": date.getFullYear()
    		};
    },
    getCurrentMonth() {
        var date = new Date();
        return {
            "start": date.getFullYear() + "-" + formatZero(date.getMonth() + 1) + "-01",
            "end": date.getFullYear() + "-" + formatZero(date.getMonth() + 1) + "-" + getLastDay(date.getFullYear(), (date.getMonth() + 1)),
            "current_1": date.getFullYear() + "-" + formatZero(date.getMonth() + 1)
        };
    },

    selectStore(labelDom, storeDom, selectDom, type) {

        if (top.base.userInfo.userLevel == 'A' || top.base.userInfo.userLevel == 'B') {
            selectDom.html(`
				<div class="input-group">
					<input class="form-control input-sm store-type" id="s5" name="storeName" readonly="readonly" placeholder="点击选择">
                    <input style="display: none" id="store-id" name="${type ? 'storeIds' : 'storeId'}">
                    <div class="input-group-addon" id="store-icon"><i class="fa fa-list"></i></div>
                </div>
            `);
        } else {
            selectDom.html(`
                <div>
                    <input type="text" class="form-control input-sm" value="${top.base.userInfo.store.name}" readonly="readonly">
                    <input type="hidden" id="store-id" name="storeId" value="${top.base.userInfo.store.storeId}">
                </div>
            `)
        }

        if (type) {
            storeTree.listenStoreMulti(labelDom.add('#store-icon'), $("#s5"), $("#store-id"));
        } else {
                        storeTree.listenStore(labelDom.add('#store-icon'), $("#s5"), $("#store-id"));
        }
    },
    selectStore2(labelDom, storeDom, selectDom, type) {
        selectDom.html(`
			<div class="input-group">
				<input class="form-control input-sm store-type" id="s5" name="storeName" readonly="readonly" placeholder="点击选择">
                <input style="display: none" id="store-id" name="${type ? 'storeIds' : 'storeId'}">
                <div class="input-group-addon" id="store-icon"><i class="fa fa-list"></i></div>
            </div>
        `);
        storeTree.listenFullStore2(labelDom.add('#store-icon'), $("#s5"), $("#store-id"));
    },
    defaultStore(labelDom, storeIdDom) {
        if (top.base.userInfo.userLevel == 'A' || top.base.userInfo.adminType == 'B2') {
            labelDom.val('[直营店（培训）]总部')
            storeIdDom.val('1297')
        }else{
        	labelDom.val(top.base.userInfo.store.name)
            storeIdDom.val(top.base.userInfo.store.storeId)
        }
    },
    defaultChildrenStore(labelDom, storeIdDom,parentStoreId) {
    	$.get(SERVER + '/store/getChildrenStoreByParentStoreId', {
    		parentStoreId: parentStoreId
		}, (json) => {
			;
			let storeList = json.data;
			for(let i=0;i<storeList.length;i++){
				labelDom.val(storeList[i].name)
	            storeIdDom.val(storeList[i].storeId)
			}

		})
    },
    defaultFullYearDate(startDateDom,endDateDom) {
        if (top.base.userInfo.userLevel == 'A' || top.base.userInfo.userLevel == 'B' || top.base.userInfo.userLevel == 'C' ) {
            var year = new Date().getFullYear()
            startDateDom.val(`${year}-01-01`)
            endDateDom.val(`${year}-12-31`)
        }
    },

    defaultTowYearDate(startDateDom,endDateDom) {
        if (top.base.userInfo.userLevel == 'A' || top.base.userInfo.userLevel == 'B' || top.base.userInfo.userLevel == 'C' ) {
            debugger
        	var year = new Date().getFullYear()
            var yearSince1 = year -1
            startDateDom.val(`${yearSince1}-01-01`)
            endDateDom.val(`${year}-12-31`)
        }
    },

    hasJurisdiction(dom) {
        let userLevel = top.base.userInfo.userLevel;
        if (!userLevel || userLevel === 'A' || userLevel === 'B') dom.hide();
    },
    getJurisdiction() {
        return top.base.userInfo.userLevel
    },

    timeStrToHours(timeStr) {
        if (!timeStr) return 0;
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours + minutes / 60;
    },
    serviceDuration(serviceItemCode,beginTimeStr,endTimeStr,storeId,parentStoreId){

        let beginNum =this.timeStrToHours(beginTimeStr) ;
        let endNum = this.timeStrToHours(endTimeStr);
        //工作时长
        let interval = Math.abs(endNum - beginNum);
        if(!Number.isInteger(interval)){
            interval = parseFloat(interval.toFixed(1))
        }
        let workHoursComm = interval > 14 ? 14 : interval > 8 ? 8 : interval;
        if(serviceItemCode!='0700'){  //所有母婴类、家政类合同计算规则
            if(interval < 8){
                workHoursComm =  interval;
            }else if(8 <= interval && interval < 14){
                workHoursComm = 8;
            }else if(interval >= 14){
                workHoursComm = '不超过14'
            }
        }
        if(storeId == '11002851'){//浙江金华永康店计算规则-2021.3.15
            if(serviceItemCode == '0100' ||
                serviceItemCode == '0600'){
                if(interval < 14){
                    workHoursComm = interval;
                }else if(interval >= 14){
                    workHoursComm = '14'
                }
            }else if(serviceItemCode == '0400' || serviceItemCode == '1500' ){
                if(interval < 14 ){
                    workHoursComm = interval - 1;
                }else if(interval >= 14){
                    workHoursComm = '14'
                }
            }else if (serviceItemCode == '1200'){
                workHoursComm = '14'
            }
        }else if(storeId == '11002792'){  //千佛山医院计算
            if(interval > 16){
                workHoursComm = 16;
            }else {
                workHoursComm = interval;
            }
        }else if(storeId == '20140'){
            if(endNum > beginNum){
                workHoursComm = endNum - beginNum;
                if(workHoursComm >=14){
                    workHoursComm = '不超过14';
                }
            }else if(endNum < beginNum){
                workHoursComm = 24-beginNum+endNum;
            }else {
                workHoursComm = 24;
            }
            if(beginNum == endNum){
                workHoursComm = '不超过14';
            }
        }else if(storeId == '20080'){
            if(endNum < beginNum){
                workHoursComm = ((24 + endNum - beginNum) % 24).toFixed(1);
            }else {
                if((endNum - beginNum) < 8){
                    workHoursComm = endNum - beginNum;
                }else if((endNum - beginNum) > 12 ){
                    workHoursComm = '不超过14';
                }else {
                    workHoursComm =   endNum - beginNum -1;
                }
            }
            if((workHoursComm+'').indexOf('.3')>-1){
                workHoursComm = workHoursComm +  0.2;
            }
        }else if(storeId == '20026' || storeId == '20027' || storeId == '20028' || storeId == '20035' || storeId == '20063'){
            //德州三八路下的五家店规则修改：2024.3.15
            //母婴生活护理、育儿嫂、育婴师
            if(serviceItemCode == '0100' || serviceItemCode =='0300' || serviceItemCode =='1300'){
                workHoursComm = endNum - beginNum - 1;

                if(endNum-beginNum > 6 && endNum < 19){
                    workHoursComm = endNum - beginNum - 1
                }
                if(endNum-beginNum > 6 &&  endNum >= 19){
                    workHoursComm = endNum - beginNum - 1.5
                }
                if(endNum < beginNum && beginNum >= 19){//夜班
                    workHoursComm = 8
                }
                if((endNum - beginNum) > 12 || (beginNum == 8 && endNum == 23)){//住家
                    workHoursComm = '不超过14';
                }
            }
            //家政服务、陪护老人
            if(serviceItemCode == '0400' || serviceItemCode == '1500'){

                if(endNum-beginNum > 6 && endNum < 19){
                    workHoursComm = endNum - beginNum - 1.5
                }
                if(endNum-beginNum > 6 &&  endNum >= 19){
                    workHoursComm = endNum - beginNum - 2
                }
                if(endNum < beginNum && beginNum >= 19){//夜班
                    workHoursComm = 8
                }
                if((endNum - beginNum) > 12 || (beginNum == 8 && endNum == 23)){//住家
                    workHoursComm = '不超过14';
                }
            }
            //钟点工
            if(serviceItemCode == '0600'){
                workHoursComm = endNum - beginNum
            }
            //全日制（陪护老人）
            if(serviceItemCode == '1200'){
                workHoursComm = '不超过14';
            }
            if(workHoursComm != "不超过14"){
                //四舍五入取整
                workHoursComm = Math.round(workHoursComm);
            }
        }else if(storeId == '20204'){
            if((endNum - beginNum)>=14){
                workHoursComm = '不超过14'
            }
        }
        if((serviceItemCode =='0500' || serviceItemCode =='1700' || serviceItemCode =='1800') && parentStoreId== '2' ){
            if(interval == '0' || Number(interval) >= 14 ){
                workHoursComm = '不超过16'
            }
        }
        return workHoursComm
    },

    statisticalType(userLevel, $userLevelWrap, storeId) {
        let userLevelHtml = ``;
        switch (userLevel) {
        case 'A':
            userLevelHtml = `
                    <option value="2">所有门店汇总</option>
                    <option value="5">指定门店汇总</option>`
            $userLevelWrap.html(userLevelHtml);
            break;
        case 'B':
            userLevelHtml = `
                    <option value="2">所有门店汇总</option>
                    <option value="5">指定门店汇总</option>`
            $userLevelWrap.html(userLevelHtml);
            break;
        case 'C':
            userLevelHtml = `<option value="2">本店汇总</option>`

            $userLevelWrap.html(userLevelHtml);
            $(".form-filter input[name=storeId]").val(storeId)
            break;

        }
    },
    /**
     * 身份证号校验
     * @return {boolean}
     */
    iscertNo(card){
        /*//身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
        var reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
        if (reg.test(card) === false) {
            return false;
        }
        return true;*/
        let ID = card.trim();
        if (typeof ID !== 'string') return false;
        const city = {
            11: "北京",
            12: "天津",
            13: "河北",
            14: "山西",
            15: "内蒙古",
            21: "辽宁",
            22: "吉林",
            23: "黑龙江 ",
            31: "上海",
            32: "江苏",
            33: "浙江",
            34: "安徽",
            35: "福建",
            36: "江西",
            37: "山东",
            41: "河南",
            42: "湖北 ",
            43: "湖南",
            44: "广东",
            45: "广西",
            46: "海南",
            50: "重庆",
            51: "四川",
            52: "贵州",
            53: "云南",
            54: "西藏 ",
            61: "陕西",
            62: "甘肃",
            63: "青海",
            64: "宁夏",
            65: "新疆",
            71: "台湾",
            81: "香港",
            82: "澳门",
            91: "国外"
        };
        let birthday = ID.substr(6, 4) + '/' + Number(ID.substr(10, 2)) + '/' + Number(ID.substr(12, 2));
        let d = new Date(birthday);
        let newBirthday = d.getFullYear() + '/' + Number(d.getMonth() + 1) + '/' + Number(d.getDate());
        let currentTime = new Date().getTime();
        let time = d.getTime();
        let arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        let arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        let sum = 0,
            i, residue;

        if (!/^\d{17}(\d|x)$/i.test(ID)) {
            return false;
        }
        if (city[ID.substr(0, 2)] === undefined) {
            return false;
        }
        if (time >= currentTime || birthday !== newBirthday) {
            return false;
        }
        for (i = 0; i < 17; i++) {
            sum += ID.substr(i, 1) * arrInt[i];
        }
        residue = arrCh[sum % 11];
        if (residue.toUpperCase() !== ID.substr(17, 1).toUpperCase()) {
            return false;
        }
        return true;
    },
    //手机号校验
	checkPhone(phone) {
		if (!(/^1[3456789]\d{9}$/.test(phone))) {
			return '手机号码有误';
		}
	},
    //8位以上数字+字母+字符组合
	PasswordStrength(val){
		var aLvTxt = ['','低','中','高'];
	  	var lv = 0;
	    if(val.match(/[a-zA-Z]/g)){lv++;}
	    if(val.match(/[0-9]/g)){lv++;}
	    if(val.match(/([^a-zA-Z0-9])/g)){lv++;}
	    if(val.length < 8){lv=0;}
	    if(lv > 3){lv=3;}
	    if(lv<2){
	    	return false;
	    }else{
	    	return true;
	    }
	},
	//加法函数，用来得到精确的加法结果
	//说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
	//调用：accAdd(arg1,arg2)
	//返回值：arg1加上arg2的精确结果
	accAdd(arg1,arg2){
		 var r1,r2,m;
		 try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
		 try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
		 m=Math.pow(10,Math.max(r1,r2))
		 return (arg1*m+arg2*m)/m
	}

}
